
import {
  defineComponent,
  ref,
  onMounted,
  computed,
  watchEffect,
  inject,
  reactive,
  watch,
} from "vue";
import { useStore } from "vuex";
import BillingFields from "@/components/billing/BillingDetails.vue";
import { Billing } from "@/vue-core/models/Billing.model";
import { loaderStart, loaderDone } from "@/services/Loader";
import useFilterDates from "@/composables/dates/useFilterDates";
export default defineComponent({
  setup() {
    const showGeneralPhone = ref(false);
    const generalPhone = ref("");
    const store = useStore();
    const data = computed(() => store.getters["user/data"]);
    const logged = computed(() => store.getters["user/isLogged"]);
    const bookings = computed(() => store.getters["user/getBookings"]);
    const getBookings = () => store.dispatch("user/getBookings");
    const getBillings = () => store.dispatch("user/getBillings");
    const emitter: any = inject("emitter");
    const billingData = computed(() => store.getters["user/getBillings"]);
    const { filterDatesToLocalString } = useFilterDates();
    const participantData = computed(
      () => store.getters["user/participantData"]
    );
    const eventData = computed(() => {
      return store.getters["user/eventData"];
    });
    const requestInvoice = (id) => {
      const billing = billingData.value.find((billing) => billing.id === id);
      const index = billingData.value.findIndex((billing) => billing.id === id);
      if (index > -1) {
        emitter.emit("openDialogBilling", {
          billingDataTemp: { ...billing },
          index,
        });
      }
    };
    async function downloadInvoice(id) {
      const billing = billingData.value.find((billing) => billing.id === id);
      const invoice = await store.dispatch(
        "user/getBillingInvoice",
        billing?.pdfPath
      );
      window.open(invoice, "_blank");
    }
    watchEffect(() => {
      if (eventData.value.generalPhone) {
        showGeneralPhone.value = true;
        generalPhone.value = eventData.value.generalPhone;
      } else {
        showGeneralPhone.value = false;
      }
    });
    const billingIsGenerate = (id) => {
      return billingData.value.find((billing) => {
        return billing.id === id && billing.generated;
      });
    };
    const billingIsRequest = (id) => {
      return billingData.value.find((billing) => {
        return (
          billing.id === id &&
          (billing.request || (!billing.request && !billing.generated))
        );
      });
    };

    const getBillingError = (id) => {
      const currBilling: Billing = billingData.value.find(
        (billing) => billing.id === id
      );
      return currBilling.errorStamp?.active
        ? currBilling.errorStamp?.message
        : undefined;
    };

    const billingExist = (id) => {
      return billingData.value.find((billing) => {
        return billing.id === id;
      });
    };
    onMounted(async () => {
      await getBillings();
      await getBookings();
    });
    return {
      bookings,
      data,
      logged,
      participantData,
      showGeneralPhone,
      generalPhone,
      downloadInvoice,
      requestInvoice,
      billingIsGenerate,
      billingIsRequest,
      filterDatesToLocalString,
      billingExist,
      getBillingError,
    };
  },
  components: {
    BillingFields,
  },
});
